module.exports = __webpack_public_path__ + "img/AI_ZYFW1.39495d23.png";